<div class="modal-header">
  <h4 class="modal-title">{{'choiceActionExportPrint.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner overflow-xh" maxHeightOffset>
    <p>{{'global.label.choiceActionComponents' | translate}}</p>
    <div class="ps-5">
      <div *ngIf="wsixAvailable" class="form-check">
        <input type="radio" class="form-check-input" id="radio1" name="radioGroup" [value]="types[0]" [(ngModel)]="actionType">
        <label class="form-check-label" for="radio1" [innerHTML]="'choiceActionExportPrint.label.export_wsix' | translate"></label>
      </div>
      <div class="form-check mt-3" *ngIf="wscxAvailable">
        <input type="radio" class="form-check-input" id="radio2" name="radioGroup" [value]="types[1]" [(ngModel)]="actionType" [disabled]="!wscxAvailable">
        <label class="form-check-label" for="radio2" [innerHTML]="'choiceActionExportPrint.label.export_wscx' | translate"></label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-primary btn-forward" (click)="onConfirm()">{{'global.label.next' | translate}}</button>
</div>
